import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { ToastProvider } from './components/useToast'
import { AuthProvider, useAuth } from './context/AuthContext'
import PremiumRoute from './components/PremiumRoute'
import SuscripcionActivaRoute from './components/SuscripcionActivaRoute'
import NotificacionesNativasInit from './components/NotificacionesNativasInit'
import TransaccionDetectada from './components/TransaccionDetectada'
import ThemeDecor from './components/ThemeDecor'

import './styles/global.css'

import Login from './pages/Login'
import Register from './pages/Register'
import Home from './pages/Home'
import ProtectedRoute from './components/ProtectedRoute'
import Ingresos from './pages/Ingresos'
import Gastos from './pages/gastos'
import Calendario from './pages/Calendario'
import Ahorros from './pages/Ahorros'
import Alertas from './pages/alertas'
import Analiticas from './pages/Analiticas'
import Perfil from './pages/perfil'
import Amigos from './pages/Amigos'
import Mensajes from './pages/Mensajes'
import ResetPassword from './pages/ResetPassword'
import IA from './pages/IA'
import Creadores from './pages/Creadores'
import ForgotPassword from './pages/Forgotpassword'
import AdminSugerencias from './pages/AdminSugerencias'
import MuroSugerencias from './pages/MuroSugerencias'
import Suscripcion from './pages/Suscripcion'
import DeclaracionRenta from './pages/DeclaracionRenta'
import PoliticaPrivacidad from './pages/PoliticaPrivacidad'
import EliminarCuenta from './pages/EliminarCuenta'
import EliminarDatos from './pages/EliminarDatos'

// Redirige según haya sesión o no
function RootRedirect() {
  const { session, ready } = useAuth()
  if (!ready) return null // aquí puedes poner tu splash si quieres
  return <Navigate to={session ? '/home' : '/login'} replace />
}

// Rutas que solo tienen sentido sin sesión (login, registro)
function PublicOnly({ children }) {
  const { session, ready } = useAuth()
  if (!ready) return null
  return session ? <Navigate to="/home" replace /> : children
}

export default function App() {

  useEffect(() => {
    const savedTheme = localStorage.getItem('app-theme') || 'dark'
    document.documentElement.setAttribute('data-theme', savedTheme)
  }, [])

  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>

          <NotificacionesNativasInit />
          <TransaccionDetectada />
          <ThemeDecor />
          <Routes>

            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />

            {/* Ruta pública, sin autenticación, para que Google y cualquier usuario puedan verla */}
            <Route path="/privacidad" element={<PoliticaPrivacidad />} />

            <Route path="/ingresos" element={<PremiumRoute><Ingresos /></PremiumRoute>} />
            <Route path="/gastos" element={<PremiumRoute><Gastos /></PremiumRoute>} />
            <Route path="/calendario" element={<PremiumRoute><Calendario /></PremiumRoute>} />
            <Route path="/ahorro" element={<PremiumRoute><Ahorros /></PremiumRoute>} />
            <Route path="/alertas" element={<PremiumRoute><Alertas /></PremiumRoute>} />
            <Route path="/Analiticas" element={<PremiumRoute><Analiticas /></PremiumRoute>} />
            <Route path="/declaracion-renta" element={<PremiumRoute><SuscripcionActivaRoute><DeclaracionRenta /></SuscripcionActivaRoute></PremiumRoute>} />

            <Route path="/perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />
            <Route path="/suscripcion" element={<ProtectedRoute><Suscripcion /></ProtectedRoute>} />

            <Route path="/amigos" element={<PremiumRoute><Amigos /></PremiumRoute>} />
            <Route path="/mensajes" element={<PremiumRoute><Mensajes /></PremiumRoute>} />

            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />

            <Route path="/sugerencias" element={<ProtectedRoute><AdminSugerencias /></ProtectedRoute>} />
            <Route path="/ia" element={<PremiumRoute><IA /></PremiumRoute>} />

            <Route path="/creadores" element={<ProtectedRoute><Creadores /></ProtectedRoute>} />
            <Route path="/muro-sugerencias" element={<PremiumRoute><MuroSugerencias /></PremiumRoute>} />

            {/* Sin PublicOnly a propósito: el enlace de recuperación inicia una sesión temporal */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/eliminar-cuenta" element={<EliminarCuenta />} />
            <Route path="/eliminar-datos" element={<EliminarDatos />} />

            <Route path="*" element={<RootRedirect />} />

          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  )
}